import { agencyApis } from '@apis/dashboard/agencyApis';
import { useMutation } from '@hooks/useMutation';
import { AgencyBase } from '@models/Agency';
import { useQueryClient } from '@tanstack/react-query';

export const usePostAgency = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: AgencyBase) => {
      const response = await agencyApis.post('/dashboard/agency/', {
        body: body,
      });

      return response[200];
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/dashboard/agency/']);
      },
    },
  );
};
